import { apiClient } from '~api/client';
import type { BlastLimitsResponse } from './blast-limits.types';

type BlastLimitsQueryParams = {
  /** ID of the blast to query limits for */
  blast_id?: number;
  /** Buffer distance for the query */
  query_buffer?: number;
};

const blastLimitsService = {
  /**
   * Fetch blast limits for a specific blast
   * @param blastName - Name of the blast
   * @param params - Optional query parameters (blast_id, query_buffer). query_buffer defaults to 350.
   * @returns Promise resolving to the blast limits
   */
  getBlastLimits: async (blastName: string, params: BlastLimitsQueryParams = {}): Promise<BlastLimitsResponse> => {
    const { blast_id, query_buffer = 350 } = params;
    const { data } = await apiClient.get(`/blast_limits/${encodeURIComponent(blastName)}`, {
      params: { blast_id, query_buffer, crs: 'local' },
    });

    return data;
  },
};

export { type BlastLimitsQueryParams, blastLimitsService };
